function address(state = {
  fetching: false,
  fetched: false,
  error: false,
}, action){
  switch (action.type) {
      case 'GET_ADDRESS_REJECTED':{
        return {
          ...state,
          fetched:false,
          error: action.payload,
        }
      }
      case 'ADD_ADDRESS_REJECTED':{
        return {
          ...state,
          fetched:false,
          error: action.payload,
        }
      }
      case 'UPDATE_ADDRESS_REJECTED':{
        return {
          ...state,
          fetched:false,
          error: action.payload,
        }
      }
      case 'DELETE_ADDRESS_REJECTED':{
        return {
          ...state,
          fetched:false,
          error: action.payload,
        }
      }
      default: break

   }
   return state;
}
export default address;



/** WEBPACK FOOTER **
 ** ./src/reducers/address.js
 **/